const message = {
  variant: `text.small`,
  textAlign: `center`,
  border: `none`,
  mb: 3
}

const messages = {
  success: {
    ...message,
    color: `success`,
    bg: `successLight`
  },
  error: {
    ...message,
    color: `error`,
    bg: `errorLight`
  }
}

export default messages